module.exports = /* @ngInject */ function($sce) {
	return function(text, searchString) {
		if (!searchString) {
			return $sce.trustAsHtml(window.DOMPurify.sanitize(text));
		}
        const html = text.replace(new RegExp(searchString, 'gi'), '<span class="highlight">$&</span>');

        const sanitizedHtml = window.DOMPurify.sanitize(html);

        return $sce.trustAsHtml(sanitizedHtml);
	};
}
